import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalControlService } from 'src/app/services/modal-control.service';
@Component({
  selector: 'app-trajectories-rvt-kmz',
  templateUrl: './trajectories-rvt-kmz.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class TrajectoriesRvtKmzComponent implements OnInit {

  constructor(
    private modalService: ModalControlService,
    public bsModalRef : BsModalRef,
  ) { }

  ngOnInit(): void {
  }

  cancelTrajectories():void {
    this.bsModalRef.hide();
  }

}
